module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-group element-type-part element-with-heading",
    attrs: {
      "id": "upart-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-group heading-size-group heading-format-group heading-alignment-fixed heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("REVELATION ONE SHADOWCASTER")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "upart-1-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-left inset-block"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('i', [_vm._v("“I see nobody on the road,” said Alice.")])])]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('i', [_vm._v("“I only wish I had such eyes to see Nobody!")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('i', [_vm._v("And at such a distance too!”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote-container prose with-attribution"
  }, [_c('blockquote', {
    staticClass: "prose with-attribution"
  }, [_c('p', {
    staticClass: "blockquote-attribution blockquote-position-last"
  }, [_c('span', {
    staticClass: "case-upper"
  }, [_vm._v("—LEWIS CARROLL")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e057908a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upart001.vue
// module id = 75
// module chunks = 0